const UPLOADED_CLASS = 'is-uploaded';

class Upload {
    init(wrapper) {
        this.wrapper = wrapper;
        this.id = this.wrapper.id;
        this._initElements();
        this._bindEvents();
    }

    _initElements() {
        this.uploadedData = this.wrapper.querySelector('.j-upload-description');
        this.nameWrap = this.wrapper.querySelector('.j-upload-name');
        this.deleteBtn = this.wrapper.querySelector('.j-upload-delete');
        this.uploadBtn = this.wrapper.querySelector('.j-form-file');
    }

    _bindEvents() {
        this.uploadBtn.addEventListener('change', this._uploadFile.bind(this));
        this.deleteBtn.addEventListener('click', this._deleteFile.bind(this));
    }

    _uploadFile() {
        if (!this.uploadBtn.files[0]) {
            return;
        }

        this.file = this.uploadBtn.files[0];

        this._toggleFile(this.file.name, 'add');
    }

    _deleteFile() {
        if (!this.uploadBtn.files[0]) {
            return;
        }

        this.uploadBtn.value = '';

        this._toggleFile('', 'remove');
    }

    _toggleFile(name = '', method) {
        if (this.nameWrap) {
            this.nameWrap.innerText = name;
        }

        this.uploadedData.classList[method](UPLOADED_CLASS);
    }
}

export default Upload;
